import {
  InputGroup,
  InputLeftElement,
  Input,
  InputRightElement,
  Button,
} from '@chakra-ui/react';
import { FaArrowRight } from 'react-icons/fa';
import { IoSearchSharp } from 'react-icons/io5';

const SearchBar = ({ placeholder = 'Search', onChange, onComplete }) => {
  return (
    <InputGroup>
      <InputLeftElement pointerEvents="none">
        <IoSearchSharp color="gray.300" />
      </InputLeftElement>
      <Input
        name="search"
        placeholder={placeholder}
        type={'text'}
        onChange={(e) => onChange(e.target.value)}
        _focus={{
          borderColor: 'brand.900',
        }}
        focusBorderColor="transparent"
        backgroundColor={'white'}
        autoComplete="off"
        borderWidth={2}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            onComplete();
          }
        }}
      />
      <InputRightElement>
        <Button
          name="right"
          background={'transparent'}
          _hover={{
            background: 'transaprent',
          }}
          _active={{
            background: 'transaprent',
          }}
          onClick={() => onComplete()}
          fontWeight={'medium'}
        >
          <FaArrowRight />
        </Button>
      </InputRightElement>
    </InputGroup>
  );
};

export default SearchBar;
